import { LoanAdjustmentsRequestDtoBorrowerAllowed } from 'src/generated-api-client';
import { bpmsResourcesManagerApi, requestsApi } from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

export class RequestsStoreClass extends BasicStore<LoanAdjustmentsRequestDtoBorrowerAllowed> {
    formKey =
        'embedded:deployment:forms/bp/bp-46-loan-adjustments-request.json';

    api: BasicStoreApi<LoanAdjustmentsRequestDtoBorrowerAllowed> = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                requestsApi.getLoanAdjustmentsRequests(
                    { page: DEFAULT_PAGE, size: DEFAULT_SIZE },
                    options,
                ),
            );

            return response.content || [];
        },

        loadItem: (id: number, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                requestsApi.getLoanAdjustmentsRequest(
                    { id: String(id) },
                    options,
                ),
            );
        },

        loadItemForm: (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm(
                    { formKey: this.formKey },
                    options,
                ),
            );
        },
    };
}

const DEFAULT_PAGE = 0;
const DEFAULT_SIZE = 100;

export const RequestsStore = new RequestsStoreClass();
